import * as React from "react";
const SvgTriangleLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 4L9 11L4.5 7.5L9 4Z", fill: "currentColor" }));
export default SvgTriangleLeft;
